import styled, { css } from 'styled-components';

export const FlexedListItem = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
`;

export const AlignEnd = styled.div`
  justify-content: flex-end;
  display: flex;
  width: 100%;
`;

export const DiarioHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  ${({ full }) => css`
    ${full && 'width: 100%;'}
  `}
`;
